module.exports = __webpack_public_path__ + "img/figuur2.5311f0d1.svg";